module.exports = __webpack_public_path__ + "static/media/landing_page.89c082b0.png";